import React from "react";

export const AttachedFile = ({ formData, handleChange, setFormData, getFileName, handleCommonFileChange, disabled }) => {
    return (
        <>
            <div className="item-row" data-grow="1">
                <div className="row-head">
                    <span>첨부파일</span>
                </div>
                <div className="row-content">
                    <div className="form-element">
                        <input
                            type="text"
                            readOnly
                            value={getFileName("ADD_FILE")}
                            placeholder="4MB 이하 파일로 첨부해주세요."
                            onClick={() => {
                                const uploadItem = formData.contractUploads?.find((item) => item.uploadType === "ADD_FILE");
                                if (uploadItem && uploadItem.upload && uploadItem.upload.url) {
                                    window.open(uploadItem.upload.url, "_blank");
                                } else {
                                    document.getElementById("addFileInput").click();
                                }
                            }}
                            disabled={disabled}
                        />
                    </div>
                    <div className="form-element_button">
                        {!disabled && (
                            <button
                                type="button"
                                className="btn-form_element btn-outline"
                                onClick={() => document.getElementById("addFileInput").click()}
                            >
                                파일첨부
                            </button>
                        )}
                        <input
                            type="file"
                            id="addFileInput"
                            style={{ display: "none" }}
                            accept=".pdf,.jpg,.png"
                            onChange={(e) => handleCommonFileChange(e, "ADD_FILE")}
                        />
                    </div>
                </div>
            </div>
        </>
    );
};
